import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { centerMsgBus } from '@ud/admin-framework'
import OtherSystemLoader from '../OtherSysContainer'
import UaaContainer from '../UaaContainer'
import CenterHeader from './CenterHeader'
import CenterSidebar from './CenterSidebar'
import { NotFound } from '../../components'
import { uaaCenter } from '../../uaaCenter'
import { appStore } from '../../stores'
import './CenterContainer.less'

const CenterContainer: React.FC = observer(() => {

  // const [isCenterMsgBusInit, setIsCenterMsgBusInit] = useState(false)

  useEffect(() => {
    // const initOptions = {
    //   baseURL: appStore.myUserData.urls['TBS-INFRA'],
    //   clientType: 'ManageUser',
    //   projectCode: uaaCenter.code,
    //   username: appStore.myUserData.profile.username,
    //   checkOrigin: (appCode: string, origin: string) => {
    //     let code = uaaCenter.findSystemCodeByUrl(origin)
    //     return !_.isEmpty(code) && code === appCode
    //   }
    // }
    // centerMsgBus.init(initOptions)
    // setIsCenterMsgBusInit(true)
  }, [])

  return (
    <div className="center-container">
      <CenterHeader />
      <main className="center-main">
        {appStore.showCenterSidebar && <CenterSidebar />}
        <div className={classNames('system-container', { disable: appStore.centerSidebarActive })}>
          <Switch>
            <Route path="/system/:code/:pagePath?" component={OtherSystemLoader} />
            <Route path="/uaa/" component={UaaContainer} />
            <Route path="/404" component={NotFound} exact={true} />

            <Route path="/" render={() => {
              let code = appStore.myUserData.generalMenus[0].customId
              let path = code == uaaCenter.code ? '/uaa/' : ('/system/' + code)
              if (process.env.REACT_APP_ENV == 'local') {
                if (appStore.getSystem('uaa') == null) {
                  return '你登录的账号没有uaa权限，无法进行开发调试，请换一个有权限的账号再试。'
                } else {
                  path = '/uaa'
                }
              }
              return <Redirect to={path} />
            }} exact={true} />

            <Route path="*" render={() => <Redirect to="/404" />} />
          </Switch>
        </div>
      </main>
    </div>
  )
})

export default CenterContainer
